import networkInstance from "../../services/api";
import { UNSETTLED_ORDER_ITEMS } from "../constant/admin";
import toastMessage from "../../toast";
import { CASH_COLLECTED } from "../constant/user";

export const getUnSettledOrders = () => async (dispatch) => {
  try {
    const { data } = await networkInstance.get(
      `admin/get_unsettled_orderitems`
    );
    if (data?.code === 200) {
      dispatch({
        type: "UNSETTLED_ORDER_ITEMS",
        payload: data?.data,
      });
      return data.code;
    } else {
      toastMessage("error", data?.data);
    }
  } catch (error) {
    toastMessage("error", error.message);
    console.error(error.message);
  }
};

export const collectCashAction = (payload) => async (dispatch) => {
  try {
    const { data } = await networkInstance.post(
      `admin/update_driver_wallet`, 
      payload
    );
    if (data?.code === 200) {
      debugger
      dispatch({
        type: CASH_COLLECTED,
        payload: data?.data,
      });
      toastMessage("success", data?.message);
      return data.code;
    } else {
      toastMessage("error", data?.data);
    }
  } catch (error) {
    toastMessage("error", error.message);
    console.error(error.message);
  }
};


